import { config } from "roo-shared";

/**
 * Where the user API lives.
 *
 * **`API_LATEST_ROOT_URL`, never `API_ROOT_URL`.** The web app is an evergreen client: it targets
 * `api-latest`, so it has none of mobile's slot/OTA coupling. `API_ROOT_URL` is the *pinned mobile
 * slot* — in prod it is a concrete host like `https://api3.roo.money` that `release:prepare`
 * rewrites on every rotation. Reading it here would silently tie the web app to whichever slot
 * mobile happens to be on and strand it there until the next web deploy. roo-shared's
 * `config.def.ts` says as much on the field: "Evergreen always-latest API used by the web app —
 * never a pinned slot."
 *
 * Dev: derive host + port from how the page itself was loaded, mirroring the admin SPA. The web app
 * runs at 4400+offset and the API at 3040+offset, so the offset recovered from our own port maps
 * straight onto the API port. Following `window.location.hostname` (rather than hard-coding
 * localhost) means opening the app over the LAN reaches the API at that same address for free.
 */
export function getApiRootUrl(): string {
  if (config.ENV !== "dev") {
    return config.API_LATEST_ROOT_URL;
  }
  const offset = parseInt(window.location.port || "4400", 10) - 4400;
  const url = new URL(config.API_LATEST_ROOT_URL);
  url.port = String(parseInt(url.port || "3040", 10) + offset);
  url.hostname = window.location.hostname;
  return url.origin;
}
